import { agent } from '@shared/services/agent';
import { UserInfoV2 } from '@features/settings/pages/manage-users-page-v2/ducks/ManageUsers.model';

interface UserListResponse {
  users: UserInfoV2[];
  total: number;
  skip: number;
}

// The /api/user/user-list endpoint caps `count` at 50, so page through until
// we've collected everyone assigned to the department.
export async function getAllUsersInDepartment(departmentId: number): Promise<UserInfoV2[]> {
  const pageSize = 50;
  const all: UserInfoV2[] = [];
  let skip = 0;

  while (true) {
    const response: UserListResponse = await agent.requests.get(
      `/api/user/user-list?departmentId=${departmentId}&skip=${skip}&count=${pageSize}&order=nameAz`
    );
    const users = response?.users ?? [];
    all.push(...users);

    const total = response?.total ?? all.length;
    if (users.length < pageSize || all.length >= total) {
      break;
    }
    skip += pageSize;
  }

  return all;
}
